module.exports = __webpack_public_path__ + "public/img/Menulis Konten SEO untuk Copywriter.130c54bc.png";